/* screens/dev/UiKitParts5.jsx — витрина (часть 5, S9): База знаний.
   DocumentCard (done/processing/failed/editing), DropZone (idle/uploading), QuotaBar (пороги). */

import React from 'react';
import { DocumentCard } from '../../components/patterns/DocumentCard.jsx';
import { DropZone } from '../../components/patterns/DropZone.jsx';
import { QuotaBar } from '../../components/ui/QuotaBar.jsx';
import { DOC_KIND_OPTIONS } from '../../lib/adapters/knowledge.js';
import { UiKitSection as Section, UiKitStateBox as StateBox } from './UiKitParts1.jsx';

  const { useState } = React;
  const KIND = DOC_KIND_OPTIONS;

  const DOC_DONE = {
    id: 'u-1', filename: 'Стандарты качества 2024.pdf', created_at: '2024-11-10T09:00:00Z',
    size_bytes: 1_450_000, kind: 'standards', summary_status: 'done',
    summary: 'Внутренние стандарты качества сырья: допустимые поставщики, требования к свежести, правила хранения.',
    is_image: false, deep_readable: true, url: '#',
  };
  const DOC_PROC = {
    id: 'u-2', filename: 'Список поставщиков.xlsx', created_at: '2025-01-15T08:00:00Z',
    size_bytes: 85_000, kind: 'suppliers', summary_status: 'processing',
    summary: null, is_image: false, deep_readable: false, url: '#',
  };
  const DOC_FAIL = {
    id: 'u-3', filename: 'Фото зала и интерьера.jpg', created_at: '2024-09-20T16:45:00Z',
    size_bytes: 4_100_000, kind: 'other', summary_status: 'failed',
    summary_error: 'Не удалось извлечь текст из изображения.', is_image: true, deep_readable: false, url: '#',
  };

  function KnowledgeSection() {
    const noop = () => {};
    const [uploads] = useState([
      { id: 'a', name: 'Прайс поставщика март.xlsx', pct: 64 },
      { id: 'b', name: 'Сертификаты HACCP.pdf', pct: 28 },
    ]);

    return (
      <Section id="knowledge" title="База знаний (S9)"
        sub="Карточка документа со всеми состояниями резюме (pending/processing/done/failed/editing), дроп-зона загрузки и индикатор квоты с цветовым порогом. Данные приходят пропсами; резюмированием управляет родитель (DocumentsTab).">

        <StateBox label="DocumentCard · done / processing / failed (на ≤720px → 1 колонка)">
          <div className="doc-grid">
            <DocumentCard doc={DOC_DONE} kindOptions={KIND} onChangeKind={noop} onDelete={noop} onRegenerate={noop} onRetry={noop} onSaveSummary={noop} />
            <DocumentCard doc={DOC_PROC} kindOptions={KIND} onChangeKind={noop} onDelete={noop} onRegenerate={noop} onRetry={noop} onSaveSummary={noop} />
            <DocumentCard doc={DOC_FAIL} kindOptions={KIND} onChangeKind={noop} onDelete={noop} onRegenerate={noop} onRetry={noop} onSaveSummary={noop} />
          </div>
        </StateBox>

        <StateBox label="DropZone · idle (клик/DnD) и uploading (прогресс по файлу)">
          <div className="stack stack-12">
            <DropZone onFiles={noop} fileLimitMb={10} accept=".pdf,.docx,.xlsx,.txt,image/*" />
            <DropZone onFiles={noop} uploads={uploads} />
          </div>
        </StateBox>

        <StateBox label="QuotaBar · нейтрально / warn (≥70%) / bad (≥90%)">
          <div className="stack stack-12" style={{ maxWidth: 420 }}>
            <QuotaBar icon="file" label="Файлы" used={4} limit={20} />
            <QuotaBar icon="database" label="Объём" used={38} limit={50} unit="МБ" />
            <QuotaBar icon="file" label="Файлы" used={19} limit={20} />
          </div>
        </StateBox>
      </Section>
    );
  }

export { KnowledgeSection };
